import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'

import { fetchAudits } from '../actions/audits'
import { fetchMachines } from '../actions/machines'
import { fetchCustomers } from '../actions/customers';

import { renderInputField, renderSelectField } from '../utils/forms'

class PinRecoverFilterForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = { loaded: false }

    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    const { fetchMachines, fetchCustomers, role } = this.props

    fetchMachines();
    if (role === 'ADMIN') {
      fetchCustomers();
    }

    this.load(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps)
  }

  load(props) {
    const { machines, customers, role } = props

    if (!this.state.loaded && machines && (role !== 'ADMIN' || customers)) {
      this.setState({ loaded: true })
    }
  }

  submit(props) {
    const { role, customerId } = this.props
    const customer = role === 'ADMIN' ? props.Customer : customerId

    return this.props.fetchAudits(customer, props.Machine, 'PIN_RECOVER', props.StartDate, props.EndDate)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  render() {
    const { loaded } = this.state
    const { error, submitting, handleSubmit, machines, customers, role } = this.props

    if (!loaded) {
      return <LoadingProgress />
    }

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <div className={`pinrecover-filter-grid${role !== 'ADMIN' ? ' no-customer' : ''}`}>
          {role === 'ADMIN' && (
            <div className="pinrecover-filter-group">
              <Field name="Customer" component={renderSelectField} label="Cliente">
                <option value="">Todos</option>
                {customers &&
                  customers
                    .filter(c => c.Type === 'GENERAL' || c.Type === 'LICENCIA_BASICA' || c.Type === 'LICENCIA_PRO')
                    .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                    .map(c => (
                      <option value={c._id} key={c._id}>{c.Fullname}</option>
                    ))}
              </Field>
            </div>
          )}
          <div className="pinrecover-filter-group">
            <Field name="Machine"
              component={renderSelectField}
              label="Máquina">
              <option value="">Todas</option>
              {machines.map(machine => {
                return (
                  <option value={machine._id} key={machine._id}>
                    {machine.Serial}
                  </option>
                )
              })}
            </Field>
          </div>
          <div className="pinrecover-filter-group">
            <Field name="StartDate"
              component={renderInputField}
              type="date"
              label="Fecha inicio" />
          </div>
          <div className="pinrecover-filter-group">
            <Field name="EndDate"
              component={renderInputField}
              type="date"
              label="Fecha fin" />
          </div>
          <div className="pinrecover-filter-group pinrecover-filter-action">
            <button className="pinrecover-filter-submit"
              type="submit"
              disabled={submitting}>
              <i className="fas fa-sync"></i>Actualizar
            </button>
          </div>
        </div>
        {error && <div className="alert alert-danger mt-2">{error}</div>}
      </form>
    )
  }
}

PinRecoverFilterForm = reduxForm({
  form: 'PinRecoverFilterForm',
})(PinRecoverFilterForm)

const mapStateToProps = state => ({
  machines: state.machines.machines,
  customers: state.customers.customers,
  role: state.auth.role,
  customerId: state.auth.id,
  initialValues: {
    Machine: '',
    Customer: '',
    StartDate: `${new Date().getFullYear()}-01-01`,
    EndDate: `${new Date().getFullYear()}-12-31`
  }
})

const mapDispatchToProps = dispatch => ({
  fetchAudits: bindActionCreators(fetchAudits, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(PinRecoverFilterForm)

